// eslint-disable-next-line no-shadow
export enum ReusedComponentIDs {
	PROMPT_MODAL_SCROLL_IDHAR = 'prompt_modal_scroll_idhar',
	MY_CHARACTERS_SCROLL_ID = 'my_character_scroll_id',
	STUDIO_SIDEBAR_CLICK_SCROLL_IDHAR = 'studio_sidebar_click_scroll_idhar',
	STUDIO_FEED_WRAPPER = 'studio_feed_wrapper',
	STUDIO_FEED_SCROLL_IDHAR = 'studio_feed_scroll_idhar',
	TRIGGER_STUDIO_TO_TOP_BUTTON = 'trigger_studio_to_top_button',
	TRIGGER_STUDIO_INFINITE_LOAD = 'trigger_studio_infinite_load',

	ASSET_LIBRARY_SCROLL_IDHAR = 'asset_library_scroll_idhar',
	TRIGGER_ASSET_LIBRARY_INFINITE_LOAD = 'trigger_asset_library_infinite_load',

	HOME_FOLD = 'home_fold',
	TRIGGER_PROMPTS_INFINITE_LOAD = 'trigger_prompts_infinite_load',

	PROFILE_PAGINATION_CLICK_SCROLL_IDHAR = 'profile_pagination_click_scroll_idhar',

	HOME_PAGE_FOLD = 'home-page-fold',
	TRIGGER_HOME_PROMPTS_INFINITE_LOAD = 'trigger_home_prompts_infinite_load',
	HOME_PAGE_CONTAINER = 'home-page-container',
	HOME_PAGE_HEADER = 'home-page-header',
	HOME_PAGE_SCROLL_TO_TOP = 'home_page_scroll_to_top',

	CONTROLNET_UPLOAD_PHOTO_CONT = 'controlnet-upload-photo-cont',
	FACELOCK_UPLOAD_PHOTO_CONT = 'facelock-upload-photo-cont',
	CHANGE_ANYTHING_UPLOAD_PHOTO_CONT = 'change-anything-upload-photo-cont',
	TRUE_TOUCH_UPLOAD_PHOTO_CONT = 'true-touch-upload-photo-cont',
	FACE_SWAP_UPLOAD_PHOTO_CONT = 'face-swap-upload-photo-cont',
	FACE_SWAP_UPLOAD_VIDEO_CONT = 'face-swap-upload-video-cont',
	LIP_SYNC_UPLOAD_VIDEO_CONT = 'lip-sync-upload-video-cont',
	LIP_SYNC_UPLOAD_IMAGE_CONT = 'lip-sync-upload-audio-cont',
	UPSCALE_8K_UPLOAD_PHOTO_CONT = 'upscale-8k-upload-photo-cont',
	VIDEO_ANYONE_UPLOAD_PHOTO_CONT = 'video-anyone-upload-photo-cont',
	VIDEO_ANYONE_END_FRAME_CONT = 'video-anyone-end-frame-cont',
	FACE_REPLACE_UPLOAD_PHOTO_CONT = 'face-replace-upload-photo-cont',
	FACE_REPLACE_PHOTO_CONT = 'face-replace-photo-cont',
	CHANGE_CLOTHING_INPUT_PHOTO_CONT = 'clothes-swap-upload-photo-cont',
	CHANGE_CLOTHING_TARGET_PHOTO_CONT = 'clothes-swap-photo-cont',
	PRODUCT_PHOTO_INPUT_PHOTO_CONT = 'product-photo-input-photo-cont',
	PRODUCT_PHOTO_BACKGROUND_PHOTO_CONT = 'product-photo-background-photo-cont',
	IMAGE_REFERENCE_STYLE_CONT = 'image-reference-sty-style-cont',
}
